export interface BankAccount {
    /** IBAN of the BankAccount */
    IBAN: string

    /** Optional BIC of the BankAccount */
    BIC?: string
}

export const accountNumberTypes = ['IBAN', 'ACCOUNT_NUMBER'] as const
export type AccountNumberType = (typeof accountNumberTypes)[number]

export const routingNumberTypes = ['BIC', 'SORT_CODE'] as const
export type RoutingNumberTypes = (typeof routingNumberTypes)[number]

export type PaymentDestination = {
    type: 'BANK_ACCOUNT' | 'BANK_ACCOUNT_SCAN'
    accountNumberType: 'IBAN' | 'ACCOUNT_NUMBER'
    accountNumber: string
    routingNumberType?: 'BIC' | 'SORT_CODE'
    routingNumber?: string
}
